const tagDataList = {
  default: {
    shareTitle: '이용권 : SBS',
    shareDescription: '신규 고객을 위한 특별할인',
    shareImageUrl: 'https://program-image.cloud.sbs.co.kr/og/2025/sbs_pass.png',
    currentUrl: 'https://www.sbs.co.kr/pass',
    keywords:
      'SBS,에스비에스,뉸,sbs온에어,sbs실시간,www.sbs.co.kr,sbs.co.kr,지상파,VOD 무료,SBS 드라마 무료,sbskorea,sbstv,sbs편성표,sbs 韓国,sbs korean,서울방송,Seoul Broadcasting System',
  },
  pass: { shareTitle: '이용권 : SBS' },
  point: {
    shareTitle: 'S포인트 : SBS',
    shareDescription: 'S포인트로 이용권 할인 쿠폰 사자!',
    shareImageUrl: 'https://program-image.cloud.sbs.co.kr/og/2025/sbs_pass.png',
    currentUrl: 'https://www.sbs.co.kr/pass/point',
    keywords: 'SBS, 에스비에스,다시보기,VOD, 고릴라, 라디오, TV, RADIO,인기가요,그것이알고싶다,런닝맨,NEWS, 뉴스 SBS, SBS플레이라이브,SBSPLAY라이브,SBS플레이ALLVOD,SBS플레이존,SBSALLVOD,SBS플레이,SBSVOD,SBSPLAY	,S포인트,포인트,포인트무료보기,SBS포인트'
  },
  money: { shareTitle: '머니 : SBS' },
  coupon: { shareTitle: '쿠폰 : SBS' },
  couponEnter: { shareTitle: '쿠폰등록 : SBS' },
};

export default function index(pageSection, pageCategory = '') {
  //console.log('pageSection> ' + pageSection);

  let result = { ...tagDataList['default'], ...tagDataList[pageSection] };

  return { ...result };
}
